import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import SiteFooter from "./SiteFooter";

export default function ContactFooter({ onRecruit, onCandidater }) {
  return (
    <>
      {/* Contact CTA */}
      <section id="contact" className="relative bg-[#0c1a2c] py-24">
        <div className="max-w-5xl mx-auto px-6">
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-[#12233a] to-[#0c1a2c] p-10 sm:p-14">
            <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#F5941E]/15 blur-[100px]" />
            <div className="relative grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                  Parlons de votre prochain recrutement
                </h2>
                <p className="mt-4 text-slate-300 leading-relaxed">
                  Un besoin à pourvoir ou envie de rejoindre l'industrie ?
                  Notre équipe vous répond sous 24h.
                </p>
                <div className="mt-8 space-y-4">
                  <a
                    href="mailto:contact@teamlooking-4.fr"
                    className="flex items-center gap-3 text-slate-200 hover:text-[#F5941E] transition-colors"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#F5941E]/15 text-[#F5941E]">
                      <Mail size={18} />
                    </span>
                    contact@teamlooking-4.fr
                  </a>
                  <a
                    href="tel:+33651068584"
                    className="flex items-center gap-3 text-slate-200 hover:text-[#F5941E] transition-colors"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#F5941E]/15 text-[#F5941E]">
                      <Phone size={18} />
                    </span>
                    06 51 06 85 84
                  </a>
                  <div className="flex items-center gap-3 text-slate-200">
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#F5941E]/15 text-[#F5941E]">
                      <MapPin size={18} />
                    </span>
                    5 Avenue de l'Air du Temps, 44300 Nantes
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <button
                  onClick={onRecruit}
                  className="w-full rounded-2xl bg-[#F5941E] hover:bg-[#e8850e] px-6 py-5 text-left font-semibold text-white transition-all duration-300 hover:-translate-y-0.5"
                >
                  <span className="block text-lg">Je recrute</span>
                  <span className="block text-sm font-normal text-white/80">
                    Décrivez votre besoin, on s'occupe du reste
                  </span>
                </button>
                <button
                  onClick={onCandidater}
                  className="w-full rounded-2xl border border-white/15 bg-white/5 px-6 py-5 text-left font-semibold text-white transition-all duration-300 hover:bg-white/10 hover:-translate-y-0.5"
                >
                  <span className="block text-lg">Je cherche un poste</span>
                  <span className="block text-sm font-normal text-slate-400">
                    Envoyez votre candidature en 1 minute
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </>
  );
}
